// chartColors — the bridge between the Tailwind design tokens (tailwind.config.ts)
// and recharts, which needs explicit hex (it can't read Tailwind classes). Keep
// this the SINGLE source for chart colors so charts stay on-token. If a token
// changes in tailwind.config.ts, change it here too.
//
// Agate light theme — corenet's palette (vendor/corenet/CLAUDE.md).

export const TOKENS = {
  accent: "#006BFF",
  accentHover: "#0058D9",
  success: "#52C41A",
  warning: "#FAAD14",
  danger: "#FF4D4F",
  info: "#006BFF",
  governance: "#722ED1",

  surface: "#FAFCFE",
  surfaceElev: "#FFFFFF",
  border: "#DDE2E6",
  textPrimary: "#1F1F1F",
  textSecondary: "#4A5158",
  textMuted: "#8C939B",

  riskCritical: "#FF4D4F",
  riskHigh: "#FF4D4F",
  riskMedium: "#FAAD14",
  riskLow: "#52C41A",
} as const;

// riskColor maps a Trust Registry risk rating to its token hex.
export function riskColor(risk: string | undefined): string {
  switch ((risk ?? "").toUpperCase()) {
    case "CRITICAL":
    case "HIGH":
      return TOKENS.danger;
    case "MEDIUM":
      return TOKENS.warning;
    case "LOW":
      return TOKENS.success;
    default:
      return TOKENS.textMuted;
  }
}

// coverageColor maps a discovery coverage_state to a token hex (alert states
// hot, governed cool).
export function coverageColor(state: string | undefined): string {
  switch (state) {
    case "ungoverned_local":
      return TOKENS.danger;
    case "drifting":
      return TOKENS.warning;
    case "local_active":
      return TOKENS.warning;
    case "both_active":
      return TOKENS.info;
    case "governed":
      return TOKENS.success;
    case "dormant":
    default:
      return TOKENS.textMuted;
  }
}

export const COVERAGE_LABELS: Record<string, string> = {
  governed: "Governed",
  both_active: "Sandbox + laptop",
  drifting: "Drifting",
  ungoverned_local: "Ungoverned local",
  local_active: "Laptop active",
  dormant: "Dormant",
};

// A neutral categorical palette (accent-led) for series without a semantic color.
export const SERIES = [
  "#006BFF",
  "#52C41A",
  "#FAAD14",
  "#722ED1",
  "#13C2C2",
  "#EB2F96",
  "#8C939B",
  "#2F54EB",
];
